import { render, staticRenderFns } from "./ConfigureDecorate.vue?vue&type=template&id=d942a728&scoped=true"
import script from "./ConfigureDecorate.vue?vue&type=script&lang=js"
export * from "./ConfigureDecorate.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDecorate.vue?vue&type=style&index=0&id=d942a728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d942a728",
  null
  
)

export default component.exports